<script>
import axios from 'axios';
import utilsService from '@/api/utilsService';
import router from '@/routes/router';

const apiUrl = `${process.env.VUE_APP_API_URL}/api/pagos`;
const token = utilsService.getToken();

const pagoService = {
  async getEstadosOptions() {
    try {
      const response = await axios.get(`${apiUrl}/options`, {
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
      });
      return response.data;
    } catch (error) {
      throw new Error('Error fetching data: ' + error.message);
    }
  },

  async getAllEstados() {
    try {
      const response = await axios.get(`${apiUrl}`, {
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
      });
      return response.data;
    } catch (error) {
      throw new Error('Error fetching data: ' + error.message);
    }
  },

  async get(id) {
    try {
      const response = await axios.get(`${apiUrl}/${id}`, {
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
      });
      return response.data;
    } catch (error) {      
      router.push('/error');
    }
  },

  async create(formRaw) {
    try {
      const form = { ...formRaw };

      const response = await axios.post(`${apiUrl}/create`, form, {
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
      });
      return response.data;
    } catch (error) {
      console.error('Error al enviar el formulario', error);
    }
  },

  async update(formRaw, id, file) {
    try {
      const formData = new FormData();
      formData.append("nombre", formRaw.nombre);
      formData.append("fecha", formRaw.fecha);
      if (file) {
        formData.append("file", file);
      }

      const response = await axios.put(`${apiUrl}/${id}`, formData, {
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'multipart/form-data',
        },
      });

      return response.status;
    } catch (error) {
      console.error('Error al enviar el formulario', error);
    }
  },

  async deleteBy(id) {
    try {
      const response = await axios.delete(`${apiUrl}/${id}`, {
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
      });
      return response.status;
    } catch (error) {
      throw new Error('Error fetching data: ' + error.message);
    }
  },

  async getAllFiltered(formRaw) {
    try {
      const form = { ...formRaw };
      form.empresa = form.empresa || 0
      const response = await axios.post(`${apiUrl}/filtered`, form, {
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
      });
      return response.data;
    } catch (error) {
      throw new Error('Error fetching data: ' + error.message);
    }
  },

  async getReporteEstadoPago(estadoPago, empresa) {
    try {
      const response = await axios.get(`${apiUrl}/reporte-estado-pago/`, {
        params: {
          estadoPago: estadoPago,
          empresa: empresa
        },
        headers: {
          'Authorization': `Bearer ${token}`,
        },        
        responseType: 'blob',
      });

      const disposition = response.headers['content-disposition'];
      let fileName = `reporte_material_${new Date().toISOString().slice(0, 10)}.pdf`;
      if (disposition && disposition.includes('filename=')) {
        const fileNameMatch = disposition.match(/filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/);
        if (fileNameMatch && fileNameMatch[1]) {

          fileName = fileNameMatch[1].replace(/['"]/g, '');
        }
      }

      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', fileName);

      document.body.appendChild(link);
      link.click();

      document.body.removeChild(link);

    } catch (error) {
      if (error.response && error.response.status === 404) {
            throw new Error("No hay datos para el estado de pago seleccionado.");
        
      } else {
        throw new Error('Error al obtener los datos, intente nuevamente.');
      }
    }
  }
};

export default pagoService;
</script>
